import React, { useState, useEffect } from 'react';
import { db, auth } from './firebase';
import { collection, onSnapshot, query, addDoc, serverTimestamp, deleteDoc, doc } from 'firebase/firestore';
import * as Icons from 'react-icons/fa';

function Staff() {
  const [user, setUser] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [staff, setStaff] = useState([]);
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("Agent");

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    auth.onAuthStateChanged((u) => {
      setUser(u);
      if (u) {
        const q = query(collection(db, "businesses", u.uid, "staff"));
        onSnapshot(q, (snapshot) => {
          setStaff(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
        });
      }
    });
  }, []);

  const handleAddStaff = async (e) => {
    e.preventDefault();
    if (!email) return;
    await addDoc(collection(db, "businesses", user.uid, "staff"), {
      email: email.toLowerCase(),
      role,
      status: 'Active',
      addedAt: serverTimestamp()
    });
    setEmail("");
  };

  if (!user) return <div style={{ padding: '20px' }}>Loading...</div>;

  return (
    <div style={{ fontFamily: '"Inter", sans-serif' }}>
      <div style={{ marginBottom: '30px' }}>
        <h2 style={{ fontWeight: '800', color: '#0f172a' }}>Staff Manager</h2>
        <p style={{ color: '#64748b', fontSize: '14px' }}>Manage team access for your spa.</p>
      </div>

      <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', gap: '20px' }}>
        <div style={{ flex: 1, background: 'white', padding: '25px', borderRadius: '16px', border: '1px solid #f1f5f9' }}>
          <h3 style={{ fontSize: '16px', marginBottom: '20px' }}>Add Team Member</h3>
          <form onSubmit={handleAddStaff} style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
            <input placeholder="Email Address" value={email} onChange={(e) => setEmail(e.target.value)} style={{ padding: '12px', borderRadius: '8px', border: '1px solid #cbd5e1' }} />
            <select value={role} onChange={(e) => setRole(e.target.value)} style={{ padding: '12px', borderRadius: '8px', border: '1px solid #cbd5e1', background: 'white' }}>
              <option value="Agent">Agent</option>
              <option value="Admin">Admin</option>
            </select>
            <button type="submit" style={{ background: '#4f46e5', color: 'white', border: 'none', padding: '12px', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer' }}>Invite Member</button>
          </form>
        </div>

        <div style={{ flex: 2, background: 'white', borderRadius: '16px', border: '1px solid #f1f5f9', overflow: 'hidden' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead style={{ background: '#f8fafc' }}>
              <tr>
                <th style={{ padding: '15px', textAlign: 'left', fontSize: '12px', color: '#64748b' }}>User</th>
                <th style={{ padding: '15px', textAlign: 'left', fontSize: '12px', color: '#64748b' }}>Role</th>
              </tr>
            </thead>
            <tbody>
              {staff.map(member => (
                <tr key={member.id} style={{ borderBottom: '1px solid #f8fafc' }}>
                  <td style={{ padding: '15px', fontSize: '14px' }}>{member.email}</td>
                  <td style={{ padding: '15px' }}><span style={{ background: '#e0e7ff', color: '#4338ca', padding: '4px 8px', borderRadius: '6px', fontSize: '11px', fontWeight: 'bold' }}>{member.role}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default Staff;